import * as Actions from './actions';

export function googleDriveReducer(state = null, action) {
  switch (action.type) {
    case Actions.UPLOADING_FILE_TO_GOOGLE_DRIVE:
      return null;
    case Actions.FILE_TERMINATE_LOADING:
      return action.file;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/DriveService/reducer.js